import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 9 6",
	style: {
		width: ".75em",
		height: ".5em"
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			fill: "#fff",
			width: 9,
			height: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#fff",
			y: 3,
			width: 9,
			height: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#0039a6",
			y: 2,
			width: 9,
			height: 2
		})
	]
});
export default SvgRu;
